import React from "react";
import { connect } from "react-redux";
import { Route, Switch, withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import PermissionDeniedComp from "Component/PermissionDeniedComp/PermissionDeniedComp";
import { SetAppMode } from "../../Actions/commonAction";
import PageNotFound from "../../Component/NotFound/index";
import { NAVIGATION } from "../../Constants";
import { backToHome } from "../../Handlers/setters";
import { getFormattedMenuList } from "../../Utils";
import Configs from "../../Constants/Configs";
import BusinessConfigRoutes from "./business-configration";
import ConfigLandingPage from "./ConfigMode/ConfigLandingPage";
import CustomData from "./ConfigMode/HRIS/Employee/CustomData";
import CommonAccess from "./ConfigMode/HRIS/Employee/CommonAccess";

import ApprovalWorkflow from "./ConfigMode/HRIS/Employee/ApprovalWorkflow/ApprovalWorkflow";
import ApprovalWorkflowList from "./ConfigMode/HRIS/Employee/ApprovalWorkflow/ApprovalWorkflowList";
import EmpCode from "./ConfigMode/HRIS/Employee/EmpCode/EmpCode";
import EmpCodePreview from "./ConfigMode/HRIS/Employee/EmpCode/EmpPreview";
import ExitPolicy from "./ConfigMode/HRIS/Employee/ExitPolicy";
import ExitReasons from "./ConfigMode/HRIS/Employee/ExitReasons";
import Probation from "./ConfigMode/HRIS/Employee/employee/probation-plan";
import PermissionPolicy from "./ConfigMode/HRIS/Employee/PermissionProfile/permissionPolicy";
import PermissionPolicyList from "./ConfigMode/HRIS/Employee/PermissionProfile/permissionPolicylist";
import PermissionSettings from "./ConfigMode/HRIS/Employee/PermissionProfile/permissionSettings";
import Compensator from "./ConfigMode/Pay/Expense/Compensator";
import CurrencyConversion from "./ConfigMode/Pay/Expense/Currencyconversions";
import Expensecycle from "./ConfigMode/Pay/Expense/Expensecycle";
import Expensetype from "./ConfigMode/Pay/Expense/Expensetype";
import FuelConfig from "./ConfigMode/Pay/Expense/FuelConfig";
import ExpensePolicy from "./ConfigMode/Pay/Expense/Policy";
import Payroll from "./ConfigMode/Pay/Payroll";
import PolicyCenter from "./ConfigMode/Resolve/PolicyCenter/index";
import ProfilePrivacy from "./EmpProfile/ProfilePrivacy";
import Track from "./Track";
import Templates from "./ConfigMode/Organize/HrLetters/Templates";
import PageLayout from "./ConfigMode/Organize/HrLetters/PageLayout";
import Signatories from "./ConfigMode/Organize/HrLetters/Signatories";
import Checklist from "./ConfigMode/Resolve/Checklist/index";
import Okr from "./ConfigMode/Perform/Okr/index";
import PerformanceCycle from "./ConfigMode/Perform/PerformanceCycle/index";
import ReviewStruture from "./ConfigMode/Perform/360DegreeReview/ReviewStructure";
import RatingScale from "./ConfigMode/Perform/360DegreeReview/RatingScale";
import Remainder from "./ConfigMode/Perform/360DegreeReview/Remainder";
import CompetencyRepository from "./ConfigMode/Perform/360DegreeReview/CompetencyRepository";
import ObjectiveUnit from "./ConfigMode/Perform/Okr/ObjectiveUnit";
import ReviewForm from "./ConfigMode/Perform/360DegreeReview/ReviewForm";
import JobsCreation from "./ConfigMode/Recruit/JobsCreation";
import ScreeningQuestions from "./ConfigMode/Recruit/ScreeningQuestions";
import CandidateSource from "./ConfigMode/Recruit/CandidateSource";
import BotIdentity from "./ConfigMode/Recruit/BotIdentity";
import Recruiters from "./ConfigMode/Recruit/Recruiters";

import PipelineMailTemplates from "./ConfigMode/Recruit/PipelineMailTemplates";
import CareerPage from "./ConfigMode/Recruit/CareerPage";
import Pipeline from "./ConfigMode/Recruit/Pipeline";
import TicketCategory from "./ConfigMode/Hrops/Helpdesk/TicketCategory";
import CannedResponses from "./ConfigMode/Hrops/Helpdesk/CannedResponses";
import GlobalDefault from "./ConfigMode/HRIS/AccountManagement/globalDefault";
import InterfaceBranding from "./ConfigMode/HRIS/AccountManagement/interfaceBranding";
import EmailBranding from "./ConfigMode/HRIS/AccountManagement/emailBranding";
import IncorporationDetails from "./ConfigMode/HRIS/AccountManagement/incorporationDetails";
import CompanyOffices from "./ConfigMode/HRIS/AccountManagement/companyOffices";

import AssetsCategory from "./ConfigMode/Hrops/Assets";

class ConfigRoutes extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isConfigAvailable: false };
  }

  componentWillMount() {
    const { features } = this.props.AuthenticationAction.login;
    const [isConfigAvailable] = getFormattedMenuList(
      NAVIGATION.config,
      features,
    );
    if (isConfigAvailable) {
      window.sessionStorage.setItem("appMode", "config");
      this.props.SetAppMode("config");
      this.setState({ isConfigAvailable });
    } else {
      // eslint-disable-next-line no-alert
      // alert("You don't have enough access");
      // backToHome();
      this.setState({ isConfigAvailable: false });
      return;
    }
    if (
      this.props.history.location.pathname == "/config" ||
      this.props.history.location.pathname == "/config/"
    ) {
      this.props.history.push("/config/dashboard");
    }
  }

  render() {
    return (
      <div>
        {this.state.isConfigAvailable ? (
          <div style={{ width: "100%" }}>
            <Switch>
              <Route
                path={`${this.props.match.path}/track`}
                component={Track}
              />
              <Route
                exact
                path={`${this.props.match.path}/dashboard`}
                component={ConfigLandingPage}
              />
              <Route
                exact
                path={`${this.props.match.path}/hris/employee/employee_id`}
                component={EmpCode}
              />
              <Route
                path={`${this.props.match.path}/hris/employee/probation`}
                component={Probation}
              />
              {/* <Route
              exact
              path={`${this.props.match.path}/hris/employee/probation/create`}
              component={Probation}
            /> */}
              <Route
                exact
                path={`${this.props.match.path}/hris/employee/empcodepreview`}
                component={EmpCodePreview}
              />
              <Route
                exact
                path={`${this.props.match.path}/hris/employee/approval_workflow/create`}
                component={ApprovalWorkflow}
              />
              <Route
                exact
                path={`${this.props.match.path}/hris/employee/approval_workflow/:workflowid`}
                component={ApprovalWorkflow}
              />
              <Route
                exact
                path={`${this.props.match.path}/hris/employee/approval_workflow`}
                component={ApprovalWorkflowList}
              />
              <Route
                exact
                path={`${this.props.match.path}/hris/employee/custom_data`}
                component={CustomData}
              />
              <Route
                exact
                path={`${this.props.match.path}/hris/employee/custom_data/create`}
                component={CustomData}
              />
              <Route
                exact
                path={`${this.props.match.path}/hris/employee/custom_data/edit`}
                component={CustomData}
              />
              <Route
                exact
                path={`${this.props.match.path}/hris/employee/common_access`}
                component={CommonAccess}
              />
              <Route
                exact
                path={`${this.props.match.path}/hris/employee/default_privacy`}
                component={ProfilePrivacy}
              />
              <Route
                exact
                path={`${this.props.match.path}/hris/employee/default_permission`}
                component={PermissionSettings}
              />
              <Route
                exact
                path={`${this.props.match.path}/hris/employee/permission_policy`}
                component={PermissionPolicyList}
              />
              <Route
                exact
                path={`${this.props.match.path}/hris/employee/permission_policy/create`}
                component={PermissionPolicy}
              />
              <Route
                exact
                path={`${this.props.match.path}/hris/employee/permission_policy/:profileid`}
                component={PermissionPolicy}
              />
              <Route
                path={`${this.props.match.path}/hris/employee/exit_policy`}
                component={ExitPolicy}
              />
              <Route
                path={`${this.props.match.path}/hris/employee/exit_reason`}
                component={ExitReasons}
              />
              <Route
                exact
                path={`${this.props.match.path}/hris/employee/default_permission/:profileid`}
                component={PermissionSettings}
              />
              <Route
                exact
                path={`${this.props.match.path}/pay/expense/expense_cycle`}
                component={Expensecycle}
              />
              <Route
                exact
                path={`${this.props.match.path}/pay/expense/fuelconfig`}
                component={FuelConfig}
              />
              <Route
                exact
                path={`${this.props.match.path}/pay/expense/type`}
                component={Expensetype}
              />
              <Route
                exact
                path={`${this.props.match.path}/pay/expense/currency_conversion`} // /config/pay/expense/currency_Conversions
                component={CurrencyConversion} // CurrencyConversion
              />
              <Route
                exact
                path={`${this.props.match.path}/pay/expense/compensator`}
                component={Compensator}
              />
              <Route
                path={`${this.props.match.path}/pay/expense/policy`}
                component={ExpensePolicy}
              />
              {
                <Route
                  path={`${this.props.match.path}/resolve/policy_center`}
                  component={PolicyCenter}
                />
              }
              <Route
                path={`${this.props.match.path}/organise/letter/template`}
                component={Templates}
              />
              <Route
                path={`${this.props.match.path}/organise/letter/page_layout`}
                component={PageLayout}
              />
              <Route
                path={`${this.props.match.path}/organise/letter/signatory`}
                component={Signatories}
              />
              {/* {Configs.MODE === "DEV" && ( */}
              <Route
                path={`${this.props.match.path}/resolve/checklist`}
                component={Checklist}
              />
              {/* )} */}
              {
                <Route
                  path={`${this.props.match.path}/pay`}
                  component={Payroll}
                />
              }
              {/* <Route
            exact
            path={`${this.props.match.path}/checklist`}
            component={CheckList}
          /> */}
              <Route
                path={`${this.props.match.path}/hris/company`}
                component={BusinessConfigRoutes}
              />
              {
                <Route
                  exact
                  path={`${this.props.match.path}/perform/okr/misc`}
                  component={Okr}
                />
              }
              {
                <Route
                  exact
                  path={`${this.props.match.path}/perform/successunit`}
                  component={ObjectiveUnit}
                />
              }
              {
                <Route
                  exact
                  path={`${this.props.match.path}/perform/360/cycle`}
                  component={PerformanceCycle}
                />
              }
              {
                <Route
                  path={`${this.props.match.path}/perform/360/structure`}
                  component={ReviewStruture}
                />
              }
              {
                <Route
                  path={`${this.props.match.path}/perform/360/rating_scale`}
                  component={RatingScale}
                />
              }
              {
                <Route
                  path={`${this.props.match.path}/perform/360/reminder`}
                  component={Remainder}
                />
              }
              {
                <Route
                  path={`${this.props.match.path}/perform/360/competency_repository`}
                  component={CompetencyRepository}
                />
              }
              {
                <Route
                  path={`${this.props.match.path}/perform/360/form`}
                  component={ReviewForm}
                />
              }

              {/* {Configs.MODE === "DEV" && ( */}
              <Route
                path={`${this.props.match.path}/recruit/recruiters`}
                component={Recruiters}
              />
              {/* )} */}

              {/* {Configs.MODE === "DEV" && ( */}
              <Route
                path={`${this.props.match.path}/recruit/career_page`}
                component={CareerPage}
              />
              {/* )} */}

              {/* {Configs.MODE === "DEV" && ( */}
              <Route
                path={`${this.props.match.path}/recruit/pipeline_email_templates`}
                component={PipelineMailTemplates}
              />
              {/* )} */}

              {/* {Configs.MODE === "DEV" && ( */}
              <Route
                path={`${this.props.match.path}/recruit/pipeline`}
                component={Pipeline}
              />
              {/* )} */}

              {/* {Configs.MODE === "DEV" && ( */}
              <Route
                path={`${this.props.match.path}/recruit/screening_questions`}
                component={ScreeningQuestions}
              />
              {/* )} */}

              {/* {Configs.MODE === "DEV" && ( */}
              <Route
                path={`${this.props.match.path}/recruit/job_templates`}
                component={JobsCreation}
              />
              {/* )} */}

              {/* {Configs.MODE === "DEV" && ( */}
              <Route
                path={`${this.props.match.path}/recruit/candidate_sources`}
                component={CandidateSource}
              />
              {/* )} */}

              {/* {Configs.MODE === "DEV" && ( */}
              <Route
                path={`${this.props.match.path}/recruit/botidentity`}
                component={BotIdentity}
              />
              {/* )} */}

              <Route
                path={`${this.props.match.path}/hrops/helpdesk/ticketcategory`}
                component={TicketCategory}
              />

              <Route
                path={`${this.props.match.path}/hrops/helpdesk/cannedresponses`}
                component={CannedResponses}
              />

              <Route
                path={`${this.props.match.path}/hris/account_management/global_default`}
                component={GlobalDefault}
              />

              <Route
                path={`${this.props.match.path}/hris/account_management/interface_branding`}
                component={InterfaceBranding}
              />

              <Route
                path={`${this.props.match.path}/hris/account_management/email_branding`}
                component={EmailBranding}
              />

              <Route
                path={`${this.props.match.path}/hris/account_management/company_offices`}
                component={CompanyOffices}
              />

              <Route
                path={`${this.props.match.path}/hris/account_management/incorporation_details`}
                component={IncorporationDetails}
              />

              <Route
                path={`${this.props.match.path}/hrops/asset/category`}
                component={AssetsCategory}
              />

              <Route
                exact
                path={`${this.props.match.path}/hrops/asset/category/create`}
                component={AssetsCategory}
              />

              <Route
                exact
                path={`${this.props.match.path}/hrops/asset/category/edit`}
                component={AssetsCategory}
              />

              <Route path="**" component={PageNotFound} />
            </Switch>
          </div>
        ) : (
          <div className="position-rel">
            <PermissionDeniedComp />
          </div>
        )}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      SetAppMode,
    },
    dispatch,
  );

const mapStateToProps = (state) => ({
  AuthenticationAction: state.AuthenticationAction,
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ConfigRoutes),
);
